import styled from "@emotion/styled";
import { Button } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { Container } from "@mui/system";
import Player from "@vimeo/player";
import { helpHttp } from "../../helper/helpHttp";
import { useUser } from "../../hooks/useUser";



export const Bizcochuelo = () => {
  const [endedVideo1, setEndedVideo1] = useState(false);
  const [preguntas, setPreguntas] = useState([]);
  const [idEvaluacion, setIdEvaluacion] = useState(null);
  const [loadingQuiz, setLoadingQuiz] = useState(true);
  const [respuestas, setRespuestas] = useState({});
  const [resultado, setResultado] = useState(null);
  const [enviando, setEnviando] = useState(false);
  const { post, get } = helpHttp();
  const { user } = useUser();

  const handleRespuesta = (preguntaIndex, opcionIndex) => {
    if (resultado) return;
    setRespuestas((prev) => ({ ...prev, [preguntaIndex]: opcionIndex }));
  };

  const handleEnviar = () => {
    if (Object.keys(respuestas).length < preguntas.length) return;

    const payload = {
      idEvaluacion: 34,
      respuestas: preguntas.map((p, i) => ({
        idPregunta: p.idPregunta,
        idRespuesta: p.opciones[respuestas[i]].idRespuesta,
      })),
    };

    setEnviando(true);
    post("evaluaciones/registrarEvaluacion", { body: payload })
      .then((data) => {
        if (data?.codigo === "200") {
          setResultado(data.datos);
        }
      })
      .catch(() => console.error("Ha ocurrido un error al registrar la evaluación"))
      .finally(() => setEnviando(false));
  };

  const handleReintentar = () => {
    setRespuestas({});
    setResultado(null);
  };

  const Capsula1 = useRef(null);

  useEffect(() => {
    const capsula1Player = new Player(Capsula1.current);

    get(`evaluaciones/getEvaluacionByModulo/30`, {
      headers: { Authorization: user.token },
    })
      .then((data) => {
        if (data?.codigo === "200" && Array.isArray(data.datos)) {
          const mapped = data.datos.map((item) => ({
            idPregunta: item.idPregunta,
            pregunta: item.pregunta,
            opciones: item.respuestas,
          }));
          setPreguntas(mapped);
        }
      })
      .catch(() => console.error("Ha ocurrido un error al cargar el cuestionario"))
      .finally(() => setLoadingQuiz(false));

    capsula1Player.on("ended", () => {
      setEndedVideo1(true);
    });
    return () => {
      capsula1Player.off("ended");
    };
  }, []);

  return (
    <StyledContainer>
      <Container>
        <StyledMain>
          <StyledVideo>
            <iframe
              ref={Capsula1}
              width="100%"
              height="100%"
              src="https://player.vimeo.com/video/1157367999"
              frameBorder="0"
              allow="fullscreen; picture-in-picture"
              title="Premezclas Introducci&amp;amp;oacute;n"
              loading="lazy"
            />
          </StyledVideo>
          <StyledCapsulas>
            <StyledQuiz>
              {/* <h2>Cuestionario: Bizcochuelo</h2> */}
              <p style={{ margin: 0, color: "#555", fontSize: "0.95rem" }}>
                Responde las siguientes preguntas para evaluar lo aprendido en
                esta cápsula. Selecciona una opción por pregunta y presiona
                <strong> Enviar respuestas</strong> cuando estés listo.
              </p>
              {loadingQuiz ? (
                <p>Cargando cuestionario...</p>
              ) : preguntas.length === 0 ? (
                <p>No se pudo cargar el cuestionario.</p>
              ) : (
                <>
              {preguntas.map((item, pi) => (
                <StyledPregunta key={pi}>
                  <p>
                    <strong>
                      {pi + 1}. {item.pregunta}
                    </strong>
                  </p>
                  <StyledOpciones>
                    {item.opciones.map((opcion, oi) => {
                      const seleccionada = respuestas[pi] === oi;
                      const estado = seleccionada ? "seleccionada" : "default";
                      return (
                        <StyledOpcion
                          key={oi}
                          estado={estado}
                          onClick={() => handleRespuesta(pi, oi)}
                        >
                          <input
                            type="radio"
                            name={`pregunta-${pi}`}
                            checked={seleccionada}
                            readOnly
                          />
                          {opcion.respuesta}
                        </StyledOpcion>
                      );
                    })}
                  </StyledOpciones>
                </StyledPregunta>
              ))}
              {!resultado ? (
                <Button
                  variant="contained"
                  onClick={handleEnviar}
                  disabled={
                    Object.keys(respuestas).length < preguntas.length ||
                    enviando
                  }
                  sx={{ alignSelf: "flex-start", mt: 1 }}
                >
                  {enviando ? "Enviando..." : "Enviar respuestas"}
                </Button>
              ) : (
                <StyledResultado>
                  <p>
                    Obtuviste <strong>{resultado.exitosas}</strong> de{" "}
                    <strong>{resultado.configuradas}</strong> respuestas correctas.
                  </p>
                  <p>
                    {resultado.aprobado
                      ? "¡Felicitaciones, aprobaste el cuestionario!"
                      : "No aprobaste el cuestionario."}
                  </p>
                  {resultado.reintentar && (
                    <Button variant="outlined" onClick={handleReintentar}>
                      Intentar nuevamente
                    </Button>
                  )}
                </StyledResultado>
              )}
                </>
              )}
            </StyledQuiz>
          </StyledCapsulas>
        </StyledMain>
      </Container>
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  background-color: #e5e5e5;
  min-height: calc(100vh - 64px);
  display: flex;
  align-items: center;
`;

const StyledMain = styled.div`
  padding-top: 120px;
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const StyledVideo = styled.div`
  width: 100%;
  aspect-ratio: 16/9;
`;

const StyledCapsulas = styled.div`
  display: flex;
  justify-content: space-between;
  > section {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 10px;
    width: 30%;
    height: auto;
  }
`;

const StyledQuiz = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  background: #fff;
  border-radius: 12px;
  padding: 32px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);

  h2 {
    margin: 0;
    font-size: 1.4rem;
    color: #222;
  }
`;

const StyledPregunta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  p {
    margin: 0;
    font-size: 1rem;
    color: #333;
  }
`;

const StyledOpciones = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const colorMap = {
  default: { bg: "#f5f5f5", border: "#ccc", text: "#333" },
  seleccionada: { bg: "#e3f2fd", border: "#1976d2", text: "#1976d2" },
  correcto: { bg: "#e8f5e9", border: "#388e3c", text: "#388e3c" },
  incorrecto: { bg: "#ffebee", border: "#d32f2f", text: "#d32f2f" },
};

const StyledOpcion = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.95rem;
  transition: background 0.2s;
  background-color: ${({ estado }) =>
    colorMap[estado]?.bg ?? colorMap.default.bg};
  border: 1.5px solid
    ${({ estado }) => colorMap[estado]?.border ?? colorMap.default.border};
  color: ${({ estado }) => colorMap[estado]?.text ?? colorMap.default.text};

  input {
    accent-color: currentColor;
    cursor: pointer;
  }
`;

const StyledResultado = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  p {
    margin: 0;
    font-size: 1.1rem;
    color: #333;
  }
`;
